import styles from './Tutorial.module.css';
import Text from '../components/Text';

const commands = [
  {
    command: '/farm',
    usage: '/farm <configname> <howToGetThere> <blocks...>',
    descriptionKey: 'TUTORIAL_CMD_FARM_DESC',
    example: '/farm Base "/home farm" sand log:2'
  },
  {
    command: '/readnbt',
    usage: '/readnbt',
    descriptionKey: 'TUTORIAL_CMD_READNBT_DESC',
    example: '/readnbt'
  },
  {
    command: '/unloadarea',
    usage: '/unloadarea <dropconfigname> <howToGetThere>',
    descriptionKey: 'TUTORIAL_CMD_UNLOADAREA_DESC',
    example: '/unloadarea Base "/home spawner"'
  },
  {
    command: '/generatemapping',
    usage: '/generatemapping <type> <outputPath>',
    descriptionKey: 'TUTORIAL_CMD_GENERATEMAPPING_DESC',
    example: '/generatemapping item "/home/mappings/items.json"'
  },
  {
    command: '/compress',
    usage: '/compress',
    descriptionKey: 'TUTORIAL_CMD_COMPRESS_DESC',
    example: '/compress'
  },
  {
    command: '/fb',
    usage: '/fb',
    descriptionKey: 'TUTORIAL_CMD_FB_DESC',
    example: '/fb'
  },
  {
    command: '/select',
    usage: '/select',
    descriptionKey: 'TUTORIAL_CMD_SELECT_DESC',
    example: '/select'
  },
  {
    command: '/goto',
    usage: '/goto <x> <y> <z>',
    descriptionKey: 'TUTORIAL_CMD_GOTO_DESC',
    example: '/goto 100 64 200'
  },
  {
    command: '/cancel',
    usage: '/cancel',
    descriptionKey: 'TUTORIAL_CMD_CANCEL_DESC',
    example: '/cancel'
  },
  {
    command: '/signall',
    usage: '/signall <text>',
    descriptionKey: 'TUTORIAL_CMD_SIGNALL_DESC',
    example: '/signall &cHallo &aDu'
  },
  {
    command: '/drop',
    usage: '/drop <configname>',
    descriptionKey: 'TUTORIAL_CMD_DROP_DESC',
    example: '/drop Base'
  },
  {
    command: '/clearbbs',
    usage: '/clearbbs',
    descriptionKey: 'TUTORIAL_CMD_CLEARBBS_DESC',
    example: '/clearbbs'
  },
  {
    command: '/forcerecordjobs',
    usage: '/forcerecordjobs',
    descriptionKey: 'TUTORIAL_CMD_FORCERECORDJOBS_DESC',
    example: '/forcerecordjobs'
  }
];

export default function Tutorial() {
  return (
    <div class="dashboard-page">
      <h1><Text val="TUTORIAL_TITLE" /></h1>
      <p style={{ color: 'var(--dark-text-secondary)', margin: '0' }}>
        <Text val="TUTORIAL_INTRO" />
      </p>
      <div class={styles.commandsGrid}>
        {commands.map(cmd => (
          <div class={styles.commandCard}>
            <div class={styles.commandHeader}>
              <span class={styles.commandName}>{cmd.command}</span>
              <span class={styles.usage}>{cmd.usage}</span>
            </div>
            <div class={styles.description}><Text val={cmd.descriptionKey} /></div>
            <div class={styles.exampleBox}><code class={styles.exampleCode}>{cmd.example}</code></div>
          </div>
        ))}
      </div>
      <div class={styles.tipsSection}>
        <h2><Text val="TUTORIAL_TIPS_TITLE" /></h2>
        <ul>
          <li><Text val="TUTORIAL_TIP_HELP" /></li>
          <li><Text val="TUTORIAL_TIP_ARGS" /></li>
          <li><Text val="TUTORIAL_TIP_CONFIGS" /></li>
          <li><Text val="TUTORIAL_TIP_COPY" /></li>
        </ul>
      </div>
    </div>
  );
}
